import { InteractionEvent, InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

export function trackServiceBoxClicked(serviceName: string, url: string): void {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.OPEN_TIPS_AND_SERVICES,
    h_event_label_008: serviceName,
    h_target_url_029: url,
  });
}
